import { Products } from '@ori-ui/icons';
import useTestId from '@ori/testid-generator';
import { IMAGE_PLACEHOLDER, IMAGE_PLACEHOLDER_BACKGROUND } from '../../common';
import { Background, Root } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ImagePlaceholder = ({
  height,
  isLoadingPlaceholder,
  isSquare,
  testId,
  width,
  ...htmlDivElementProps
}) => {
  const {
    getTestId
  } = useTestId();
  return /*#__PURE__*/_jsxs(Root, {
    ...htmlDivElementProps,
    height: height,
    isSquare: isSquare,
    width: width,
    "data-testid": testId ?? getTestId(IMAGE_PLACEHOLDER),
    children: [/*#__PURE__*/_jsx(Products, {
      fontSize: "inherit"
    }), isLoadingPlaceholder ? /*#__PURE__*/_jsx(Background, {
      animation: "wave",
      height: "100%",
      variant: "rectangular",
      width: "100%",
      "data-testid": getTestId(IMAGE_PLACEHOLDER_BACKGROUND)
    }) : null]
  });
};
//# sourceMappingURL=ImagePlaceholder.js.map